const initialState = {
    isMainMenuOpen: false,
    isRightSidebarOpen: false,
    savedSettingsRoute: '/'
}

export default initialState;
